function toggleMenu() {
    const hamburgerMenu = document.getElementById('hamburgerMenu');
    const mobileMenu = document.getElementById('mobileMenu');
    const body = document.body;

    // メニューの表示/非表示を切り替える
    hamburgerMenu.classList.toggle('active');
    mobileMenu.classList.toggle('active');

    // スクロール制御の処理
    if (mobileMenu.classList.contains('active')) {
        body.classList.add('no-scroll');  // スクロール無効
    } else {
        body.classList.remove('no-scroll');  // スクロール有効
    }
}

/* 追跡ヘッダー */
/*
let lastScrollTop = 0;
const header = document.querySelector('.header');
window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop) {
        header.style.top = '-60px';
    } else {
        header.style.top = '0';
    }
    lastScrollTop = scrollTop;
});
*/